export const XlsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_198_3503)">
      <path
        d="M16.0004 4.27502H9.83789V8.00002H16.0004V4.27502Z"
        fill="#21A365"
      />
      <path d="M16.0004 8H9.83789V11.725H16.0004V8Z" fill="#107C41" />
      <path d="M9.8375 4.27502H3.6875V8.00002H9.8375V4.27502Z" fill="#107C41" />
      <path
        d="M9.8377 11.725V8H3.7002V11.725V12.2625V14.7125C3.7002 15.1125 4.0252 15.4375 4.4252 15.4375H15.2627C15.6627 15.4375 15.9877 15.1125 15.9877 14.7125V11.725H9.8377Z"
        fill="#185B37"
      />
      <path
        d="M15.2627 0.5625H9.8252V4.2875H16.0002V1.2875C15.9877 0.8875 15.6627 0.5625 15.2627 0.5625Z"
        fill="#33C481"
      />
      <path
        d="M9.8374 0.5625H4.4374C4.0374 0.5625 3.7124 0.8875 3.7124 1.2875V4.275H9.8499V0.5625H9.8374Z"
        fill="#21A365"
      />
      <path
        d="M7.4377 12.0625H0.812695C0.375195 12.0625 0.0126953 11.7 0.0126953 11.2625V4.7375C0.0126953 4.3 0.375195 3.9375 0.812695 3.9375H7.4377C7.8752 3.9375 8.2377 4.3 8.2377 4.7375V11.2625C8.2377 11.7 7.8877 12.0625 7.4377 12.0625Z"
        fill="#17864C"
      />
      <path
        d="M5.0623 10.3L4.5748 9.4125C4.3748 9.0625 4.2498 8.825 4.1123 8.5625H4.0998C3.9873 8.825 3.8748 9.0625 3.6873 9.4125L3.2498 10.3H2.2998L3.6498 8.0375L2.3373 5.8125H3.2998L3.7873 6.7375C3.9373 7.0125 4.0498 7.2375 4.1623 7.4875H4.1873C4.3123 7.2125 4.3998 7.0125 4.5498 6.7375L5.0373 5.8125H5.9873L4.6498 8L6.0373 10.3H5.0623Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M8.3373 4.66248C8.3373 4.68748 8.3373 4.71248 8.3373 4.73748V11.2625C8.3373 11.7 7.9748 12.0625 7.5373 12.0625H3.7998V12.775H8.1998C8.6373 12.775 8.9998 12.4125 8.9998 11.975V5.44998C9.0123 5.04998 8.7123 4.71248 8.3373 4.66248Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_198_3503">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
